<template>
  <v-autocomplete
    v-model="selected_ies"
    class="pt-6"
    :filter="filterIses"
    @change="goToSelectedIes"
    :items="ises"
    clearable
    color="accent"
    label="Buscar Institución"
    item-text="nombre"
    item-value="id"
    prepend-icon="search"
  >
    <template v-slot:item="data">
      <v-list-item-avatar>
        <v-img 
          contain
          :src="data.item.logo"
        ></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-html="data.item.siglas"></v-list-item-title>
        <v-list-item-subtitle v-html="data.item.nombre"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>


<script>
import { mapState, } from "vuex";

export default {
  name: 'SearchIses',
  components: {
  },
  data(){
    return {
      selected_ies: undefined,
    }
  },
  computed:{
    ...mapState({
      ises: state => state.ises,
      //selected_ies: "",
    }), 
  },
  methods: {
    filterIses(item, queryText, itemText){
      const complete_name = itemText.toLowerCase()
      const siglas = item.siglas.toLowerCase()
      const searchText = queryText.toLowerCase()
      return complete_name.indexOf(searchText) > -1 ||
      siglas.indexOf(searchText) > -1        
    },
    goToSelectedIes() {
      if (!!this.selected_ies) {
        this.$router.push({ path: `/ies/${this.selected_ies}`})
        this.$nextTick(()=>{
          this.selected_ies = undefined
        })
      }
    },
  },  
  mounted(){

  },
}
</script>

<style lang="scss" scoped>
#app-width {
}
</style>

